// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EventDetailsSkeleton_wrapper__f_OtU","container":"EventDetailsSkeleton_container__p2NDK"};